<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-outTabs">
        <div id="tab_wizard2"></div>

        <ejs-tab
          ref="myTabs"
          id="realTimeTab"
          heightAdjustMode="None"
          :showCloseButton="true"
          :removing="beforeRemoving"
        >
          <e-tabitems>
            <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
            <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
        <!-- 首页 -->
        <div id="HomePage">
          <RealTimeTaskPageContent
            ref="homePage"
            @createRealTaskAddTabEmit="createRealTaskAddTabEmit"
          ></RealTimeTaskPageContent>
        </div>

        <div id="realTaskPage1" style="display:none;">
          <RealTaskTab ref="tab1"></RealTaskTab>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import RealTimeTaskPageContent from '../../../components/pmConfig/4gproject/RealTimeTask/RealTimeTaskPageContent';
import RealTaskTab from '../../../components/pmConfig/4gproject/RealTimeTask/RealTaskTab';
import { EventBus } from '../../../plugins/eventBus';

class Tab {
  constructor(sequence) {
    this.sequence = sequence;
    this.isUse = false;
    this.elementId = `e-item_${this.sequence}`;
    this.parameter = undefined;
  }
}

export default {
  name: 'RealTimeTaskPage',
  components: {
    BasicLayout,
    RealTimeTaskPageContent,
    RealTaskTab
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.realTimeMeasurement')}`
      },
      headerText0: {
        text: this.$t('Pm.homePage')
      },
      content0: '#HomePage',
      headerText1: {
        text: this.$t('Pm.realTimeMeasurement')
      },
      content1: '#realTaskPage1',
      tabs: [],
      test: {}
    };
  },
  mounted() {
    // 页面一共支持几个标签.注意和页面的realTaskPage1个数保持一致
    const numberOfTags = 1;

    for (let index = 0; index < numberOfTags; index++) {
      this.tabs.push(new Tab(index + 1));
      this.$refs.myTabs.hideTab(index + 1, true);
    }
  },
  methods: {
    createRealTaskAddTabEmit(args) {
      console.log('createRealTaskAddTabEmit', args);

      let currentTabIndex = undefined;

      for (let index = 0; index < this.tabs.length; index++) {
        if (this.tabs[index].isUse == false) {
          this.tabs[index].isUse = true;
          this.tabs[index].parameter = args;
          this.tabs[index].sequence = index + 1;
          currentTabIndex = index + 1;
          break;
        }
      }

      if (currentTabIndex === undefined) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.atMostOneRealTask') });
        return;
      }

      const tabObj = this.$refs.myTabs.ej2Instances;

      // 动态设置标题
      const eitem_1 = document.getElementById(tabObj.itemIndexArray[currentTabIndex]);
      if (eitem_1) {
        eitem_1.getElementsByClassName('e-tab-text')[0].innerHTML = args.title;
      }

      this.$refs.myTabs.hideTab(currentTabIndex, false);
      this.$refs.myTabs.select(currentTabIndex);
      this.$refs[`tab${currentTabIndex}`].startup(args);
    },
    // 关闭标签页面之前的处理
    beforeRemoving(args) {
      args.cancel = true;

      if (args.removedIndex === 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.notCloseHome') });
        return;
      }

      for (let index = 0; index < this.tabs.length; index++) {
        if (this.tabs[index].sequence == args.removedIndex) {
          this.$refs.myTabs.hideTab(args.removedIndex, true);
          this.$refs[`tab${args.removedIndex}`].shutdown();

          let taskId = this.tabs[index].parameter.taskId;


          this.axios.get(`/lte/pm/currenttime/taskmanagement/stopTask?taskId=${taskId}`, {}).then(res => {
            console.log('stoptask', res);
            // 刷新页面
            this.$refs.homePage.refreshGridForTaskListReal();

          }).catch(err => {
            console.error(err);
          });

          // 回复初始化
          this.tabs[index].isUse = false;
          this.tabs[index].parameter = undefined;
          break;
        }
      }
    },
    //判断当前是否有可用的标签
    isTabAvailable(){
      let result = false;

      for (let index = 0; index < this.tabs.length; index++) {
        if (this.tabs[index].isUse == false) {
          result = true;
          break;
        }
      }

      return result;
    }

  }
};
</script>

<style scoped>
  ::v-deep #e-item-realTimeTab_0 [title=Close]
  {
    display: none;
  }
</style>
